const addMaterial = (state, material) => {
  state.materiales.push(material)
};

const setListMateriales = (state, listMateriales) => {
  state.materiales=listMateriales
};



export default {
  addMaterial,
  setListMateriales,
};





// WEBPACK FOOTER //
// ./src/store/modules/materiales/mutations.js